import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { listarPerfisRevenda } from "../services/api";
import PermissoesUsuario, { flagsPadrao } from "./PermissoesUsuario";

const CadastroUsuario = ({ token, initialData = {}, onSubmit, isEdit = false, audiencia = "revenda" }) => {
  const navigate = useNavigate();

  const [perfis, setPerfis] = useState([]);
  const [permissoes, setPermissoes] = useState(flagsPadrao(audiencia));
  const [usuario, setUsuario] = useState({
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    ativo: true,
    perfilId: 1,
  });

  useEffect(() => {
    if (audiencia === "distribuidor") return;
    listarPerfisRevenda(token)
      .then((res) => setPerfis(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPerfis([]));
  }, [token, audiencia]);

  useEffect(() => {
    const hasInitial = initialData && Object.keys(initialData).length > 0;
    if (!hasInitial) return;

    setUsuario({
      nome: initialData.nome || "",
      telefone: initialData.telefone || "",
      email: initialData.email || "",
      senha: "",
      ativo: initialData.ativo ?? true,
      perfilId: initialData.perfilId || initialData.PerfilId || 1,
    });
    const salvas = initialData.permissoes || initialData.Permissoes;
    setPermissoes(Array.isArray(salvas) && salvas.length ? salvas : flagsPadrao(audiencia));
  }, [initialData, audiencia]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUsuario((prev) => ({
      ...prev,
      [name]: name === "perfilId" ? Number(value) : type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      Nome: usuario.nome,
      Telefone: usuario.telefone,
      Email: usuario.email,
      Ativo: Boolean(usuario.ativo),
      Senha: usuario.senha,
      PerfilId: Number(usuario.perfilId) || 1,
      Permissoes: permissoes,
    };

    if (!payload.Email) {
      alert("Email é obrigatório.");
      return;
    }

    if (!isEdit && !payload.Senha) {
      alert("Senha é obrigatória no cadastro.");
      return;
    }

    try {
      await onSubmit(payload, token);
      alert(isEdit ? "Usuário atualizado com sucesso!" : "Usuário cadastrado com sucesso!");
      navigate("/usuarios"); // ✅ rota do front revenda
    } catch (error) {
      const data = error?.response?.data;
      const msg =
        typeof data === "string"
          ? data
          : data?.message ||
            (data?.errors && Object.values(data.errors).flat().join("\n")) ||
            "Erro ao salvar usuário.";
      alert(msg);
      console.error(error);
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="zen-card rounded-2xl p-6 shadow-sm dark:backdrop-blur">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
            {isEdit ? "Editar Usuário" : "Cadastro de Usuário"}
          </h2>
          <p className="text-sm text-gray-500 dark:text-slate-300/80">
            {isEdit ? "Altere os dados do usuário." : audiencia === "distribuidor" ? "Cadastre um usuário deste distribuidor." : "Cadastre um novo usuário para sua revenda."}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 gap-4">
              {/* ativo */}
              <div className="flex items-center gap-3">
                <input
                  id="ativo"
                  type="checkbox"
                  name="ativo"
                  checked={!!usuario.ativo}
                  onChange={handleChange}
                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <label htmlFor="ativo" className="text-sm font-medium text-gray-700 dark:text-slate-200">
                  Usuário ativo
                </label>
              </div>
            </div>
          </div>

          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1">Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={usuario.nome}
                  onChange={handleChange}
                  className="w-full px-3 py-2.5 rounded-xl border outline-none transition zen-card border-gray-300 text-gray-900
                    focus:ring-2 focus:ring-blue-500/60 dark:bg-slate-950/40 dark:border-white/10 dark:text-white
                    dark:focus:ring-blue-400/40"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1">Telefone</label>
                <InputMask
                  mask="(99) 99999-9999"
                  type="text"
                  name="telefone"
                  value={usuario.telefone}
                  onChange={handleChange}
                  className="w-full px-3 py-2.5 rounded-xl border outline-none transition zen-card border-gray-300 text-gray-900
                    focus:ring-2 focus:ring-blue-500/60 dark:bg-slate-950/40 dark:border-white/10 dark:text-white
                    dark:focus:ring-blue-400/40"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={usuario.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2.5 rounded-xl border outline-none transition zen-card border-gray-300 text-gray-900
                    focus:ring-2 focus:ring-blue-500/60 dark:bg-slate-950/40 dark:border-white/10 dark:text-white
                    dark:focus:ring-blue-400/40"
                  required
                />
              </div>

              {audiencia !== "distribuidor" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1">Perfil</label>
                <select
                  name="perfilId"
                  value={usuario.perfilId}
                  onChange={handleChange}
                  className="w-full px-3 py-2.5 rounded-xl border outline-none transition zen-card border-gray-300 text-gray-900
                    focus:ring-2 focus:ring-blue-500/60 dark:bg-slate-950/40 dark:border-white/10 dark:text-white
                    dark:focus:ring-blue-400/40"
                  required
                >
                  {perfis.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.nome}
                    </option>
                  ))}
                </select>
              </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1">
                  {isEdit ? "Nova Senha (deixe em branco para não alterar)" : "Senha"}
                </label>
                <input
                  type="password"
                  name="senha"
                  value={usuario.senha}
                  onChange={handleChange}
                  className="w-full px-3 py-2.5 rounded-xl border outline-none transition zen-card border-gray-300 text-gray-900
                    focus:ring-2 focus:ring-blue-500/60 dark:bg-slate-950/40 dark:border-white/10 dark:text-white
                    dark:focus:ring-blue-400/40"
                  required={!isEdit}
                />
                {isEdit ? (
                  <p className="text-xs text-gray-500 dark:text-slate-300/70 mt-1">
                    Se ficar em branco, o backend mantém a senha atual.
                  </p>
                ) : null}
              </div>
            </div>
          </div>

          <PermissoesUsuario audiencia={audiencia} value={permissoes} onChange={setPermissoes} />

          <div className="flex justify-end">
            <button
              type="submit"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition
                bg-blue-600 text-white hover:bg-blue-500"
            >
              <Save size={18} />
              {isEdit ? "Salvar Alterações" : "Cadastrar Usuário"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroUsuario;
